import React, { useState } from 'react';
import { Card, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { 
  IconMessageCircle, 
  IconEye, 
  IconEyeOff, 
  IconX, 
  IconInfoCircle 
} from '@tabler/icons-react';
import { IFRAME_SECURITY } from '../../constants/formConstants';

const Step6Playground = ({ 
  formData, 
  register, 
  setValue, 
  control, 
  errors, 
  trigger 
}) => {
  const [showPreview, setShowPreview] = useState(false);
  
  // Verificar se a URL é válida
  const isValidUrl = formData.playground_url && /^https?:\/\/.+/.test(formData.playground_url);

  const handlePreviewToggle = () => {
    setShowPreview(!showPreview);
  };

  const validatePlaygroundUrl = (value) => {
    if (!value) {
      return "URL do playground é obrigatória";
    }
    if (!/^https?:\/\/.+/.test(value)) {
      return "URL deve começar com http:// ou https://";
    }
    return true;
  };

  return (
    <div className="step-content">
      <Row className="justify-content-center">
        <Col lg={12}>
          
          <h4 className="mb-2">Playground de Testes</h4>
          <p className="text-muted mb-4">
            Forneça uma URL embedável para que os compradores possam testar seu
            agente
          </p>
          <Row>
            <Col md={12}>
              {/* Campo URL do Playground */}
              <Form.Group className="mb-4">
                <Form.Label className="fw-bold">
                  URL do Chat Embedável <span className="text-danger">*</span>
                </Form.Label>
                <Controller
                  name="playground_url"
                  control={control}
                  rules={{
                    required: "URL do playground é obrigatória",
                    validate: validatePlaygroundUrl,
                  }}
                  render={({ field }) => (
                    <Form.Control
                      {...field}
                      type="url"
                      placeholder="https://exemplo.com/chat-embed"
                      isInvalid={!!errors.playground_url}
                      className="form-control-lg"
                    />
                  )}
                />
                <Form.Text className="text-muted">
                  Digite apenas a URL, por exemplo:
                  https://exemplo.com/chat-embed
                </Form.Text>
                {errors.playground_url && (
                  <Form.Control.Feedback type="invalid">
                    {errors.playground_url.message}
                  </Form.Control.Feedback>
                )}
              </Form.Group>

              {/* Botão de Preview */}
              {isValidUrl && (
                <div className="text-center mb-4">
                  <Button
                    variant="primary"
                    onClick={handlePreviewToggle}
                    className="btn-lg px-4"
                  >
                    {showPreview ? (
                      <>
                        <IconEyeOff size={18} className="me-2" />
                        Ocultar Preview
                      </>
                    ) : (
                      <>
                        <IconEye size={18} className="me-2" />
                        Visualizar Preview
                      </>
                    )}
                  </Button>
                </div>
              )}

              {/* Preview do Playground */}
              {showPreview && isValidUrl && (
                <Card className="mb-4">
                  <Card.Header className="d-flex justify-content-between align-items-center">
                    <span className="fw-bold">Preview do Playground</span>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={handlePreviewToggle}
                    >
                      <IconX size={16} />
                    </Button>
                  </Card.Header>
                  <Card.Body className="p-0">
                    <div
                      style={{
                        width: "100%",
                        height: IFRAME_SECURITY.PLAYGROUND_HEIGHT,
                        overflow: "hidden",
                        borderRadius: "0 0 0.375rem 0.375rem",
                      }}
                    >
                      <iframe
                        src={formData.playground_url}
                        style={{
                          width: "100%",
                          height: "100%",
                          border: "none",
                        }}
                        title="Playground Preview"
                        sandbox={IFRAME_SECURITY.SANDBOX}
                      />
                    </div>
                  </Card.Body>
                </Card>
              )}

              {/* Dicas Importantes */}
              <Alert variant="info" className="d-flex">
                <IconInfoCircle size={20} className="me-3 mt-1 flex-shrink-0" />
                <div>
                  <h6 className="alert-heading mb-2">Dicas importantes:</h6>
                  <ul className="mb-0">
                    <li>A URL deve permitir incorporação via iframe</li>
                    <li>Certifique-se de que o chat funciona corretamente</li>
                    <li>Use HTTPS para maior segurança</li>
                    <li>
                      O playground será exibido na página do agente para testes
                    </li>
                    <li>
                      Clique em "Visualizar Preview" para testar a incorporação
                    </li>
                  </ul>
                </div>
              </Alert>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Step6Playground;